import { distance as levenshteinDistance } from 'fastest-levenshtein';

export type PlanEditLevel = 'none' | 'minimal' | 'moderate' | 'substantial';

// Buckets use Levenshtein edits as a percentage of the larger plan:
// none = 0 changes, minimal = about <= 2 changes per 100 chars,
// moderate = about <= 15 changes per 100 chars, substantial = more than that.
const MINIMAL_EDIT_RATIO = 0.02;
const MODERATE_EDIT_RATIO = 0.15;

const normalizePlan = (plan: string): string =>
	plan
		.replace(/\r\n?/g, '\n')
		.trim()
		.replace(/[ \t]+/g, ' ')
		.replace(/\n{3,}/g, '\n\n');

export const getPlanEditLevel = (originalPlan: string, submittedPlan: string): PlanEditLevel => {
	const normalizedOriginal = normalizePlan(originalPlan);
	const normalizedSubmitted = normalizePlan(submittedPlan);

	if (normalizedOriginal === normalizedSubmitted) {
		return 'none';
	}

	const editRatio =
		levenshteinDistance(normalizedOriginal, normalizedSubmitted) /
		Math.max(normalizedOriginal.length, normalizedSubmitted.length);

	if (editRatio <= MINIMAL_EDIT_RATIO) {
		return 'minimal';
	}

	if (editRatio <= MODERATE_EDIT_RATIO) {
		return 'moderate';
	}

	return 'substantial';
};
